export default __webpack_public_path__ + "static/media/gallery-10.25ef805f.jpg";